let endpoint

if (process.env.NODE_ENV === "development") {
  endpoint = "http://localhost:5000/api"
} else {
  endpoint = "https://fixarfolket-api.herokuapp.com/api"
}

export const get = async (url, config = {}) => {
  config.headers = config.headers || {}
  config.headers["Accept"] = "application/json"
  config.headers["Content-Type"] = "application/json"

  return await request(url, config, true)
}

export const post = async (url, config = {}) => {
  config.method = "POST"
  config.headers = config.headers || {}
  config.headers["Accept"] = "application/json"
  config.headers["Content-Type"] = "application/json"

  return await request(url, config, true)
}

export const destroy = async (url, config = {}) => {
  config.method = "DELETE"
  config.headers = config.headers || {}
  config.headers["Accept"] = "application/json"
  config.headers["Content-Type"] = "application/json"

  return await request(url, config, true)
}

export const patch = async (url, config = {}) => {
  config.method = "PATCH"
  config.headers = config.headers || {}
  config.headers["Accept"] = "application/json"
  config.headers["Content-Type"] = "application/json"

  return await request(url, config, true)
}

const request = async (url, config = {}, auth) => {
  config.headers = config.headers || {}
  config.headers["Accept"] = "application/json"
  config.headers["Content-Type"] = "application/json"

  if (auth) {
    const token = localStorage.getItem("token")

    if (token) {
      config.headers["Authorization"] =
        config.headers["Authorization"] || `Bearer ${token}`
    }
  }

  return await fetch(endpoint + url, config)
}



// WEBPACK FOOTER //
// src/utils/api.js